import React, { Component, cloneElement, PropTypes } from 'react';
import update from 'react/lib/update';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { map, addIndex, propOr } from 'ramda';

class SortableList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrayOfNodes: addIndex(map)((singleNode, id) => ({ singleNode, id }), propOr([], 'children', props)),
      arrayOfData: propOr([], 'arrayOfData', props),
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      arrayOfNodes: addIndex(map)((singleNode, id) => ({ singleNode, id }), propOr([], 'children', nextProps)),
      arrayOfData: propOr([], 'arrayOfData', nextProps),
    });
  }

  moveCard = (dragIndex, hoverIndex) => {
    const { arrayOfNodes, arrayOfData } = this.state;
    const dragCard = arrayOfNodes[dragIndex];
    const dragData = arrayOfData[dragIndex];
    this.setState(update(this.state, {
      arrayOfNodes: {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragCard],
        ],
      },
      arrayOfData: {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragData],
        ],
      },
    }));
  };
  dragEnds = () => this.props.dragEnds(this.state.arrayOfData);

  render() {
    const { arrayOfNodes } = this.state;
    const { style, className } = this.props;
    return (
      <div style={style} className={className}>
        {arrayOfNodes.map((singleNode, i) => cloneElement(singleNode.singleNode, {
          key: singleNode.id,
          index: i,
          dragEnds: this.dragEnds,
          moveCard: this.moveCard,
        }))}
      </div>
    );
  }
}

SortableList.propTypes = {
  style: PropTypes.object,
  cardStyle: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.array.isRequired,
  arrayOfData: PropTypes.array.isRequired,
  dragEnds: PropTypes.func.isRequired,
};

export default DragDropContext(HTML5Backend)(SortableList);



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/sortable-list-with-react-dnd/sortable-list.jsx